import styled from 'styled-components';

export const NumberBlock = styled.div`
    color: ${({isActive}) => isActive ? '#505154' : '#B5B5B5'};
    width: 75px;
    font-size: 18px;
    font-weight: bold;
    padding: 4px 0;
    text-align: center;
    border: 1px solid #B5B5B5;
`;

export const Arrows = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    position: absolute;
    right: 4px;
`;

export const Arrow = styled.img`
    width: 10px;
    height: 10px;
    cursor: pointer;
    
    &:hover {
        opacity: 0.5;
    }
`;

export const AttachedButton = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
`;
